import React from 'react'

const Tarjeta = ({ imagen, titulo, monto, link }) => {
  return (
    <div className="col-lg-3">
        <a href={ link }>
        <div className="card">
            <div className="card-body">
                <div className="d-flex no-block">
                    <div className="m-r-20 align-self-center">
                        <span className="lstick m-r-20"></span><img src={ imagen } alt="Income" width="50" height="50" />
                    </div>
                    <div className="align-self-center">
                        <h6 className="text-muted m-t-10 m-b-0"></h6>
                        <h2 className="m-t-0">{ titulo }</h2>
                    </div>
                </div>
            </div>
        </div>
        </a>
    </div>
  )
}

export default Tarjeta
